// Report categories and subcategories data structure
export const REPORT_CATEGORIES = [
  {
    id: "porn_content",
    name: "Pornografische Inhalte",
    subcategories: [
      { id: "sexual_content", name: "Eindeutige sexuelle Inhalte" },
      { id: "nudes", name: "Nacktheit" },
      { id: "Indecent_suggestive_material_without_nudity", name: "Anzügliches Material ohne Nacktheit" },
      { id: "Video_with_minors", name: "Video mit Minderjährigen" },
      { id: "title_or_description_is_inappriote", name: "Titel oder Beschreibung ist unangemessen" },
      { id: "porn_content_of_another_kind", name: "Pornografische Inhalte anderer Art" },
    ],
  },
  {
    id: "violent_or_repulsive_content",
    name: "Gewaltsame oder abstoßende Inhalte",
    subcategories: [
      { id: "violence_between_adults", name: "Gewalt zwischen Erwachsenen" },
      { id: "physical_attack", name: "Tätlicher Angriff" },
      { id: "youth_violence", name: "Jugendgewalt" },
      { id: "abuse_of_animals", name: "Missbrauch von Tieren" },
    ],
  },
  {
    id: "hateful_or_offensive_content",
    name: "Hasserfüllte oder beleidigende Inhalte",
    subcategories: [
      { id: "glorification_of_hatred_and_violence", name: "Verherrlichung von Hass und Gewalt" },
      { id: "abuse_of_defenseless_persons", name: "Missbrauch wehrloser Personen" },
      { id: "mobbing", name: "Mobbing" },
      { id: "title_or_description_is_inappropriate", name: "Titel oder Beschreibung ist unangemessen" },
    ],
  },
  {
    id: "dangerous_potentially_harmful_acts",
    name: "Gefährliche, potenziell schädliche Handlungen",
    subcategories: [
      { id: "abuse_of_drugs_or_drugs", name: "Missbrauch von Medikamenten oder Drogen" },
      { id: "abuse_of_fire_or_explosives", name: "Missbrauch von Feuer oder Sprengstoff" },
      { id: "suicide_or_self-injury", name: "Selbstmord oder Selbstverletzung" },
      { id: "dangerous_actions_of_another_kind", name: "Gefährliche Handlungen anderer Art" },
    ],
  },
  {
    id: "child_abuse",
    name: "Kindesmissbrauch",
    subcategories: [], // No subcategories for this category
  },
  {
    id: "support_for_terrorism",
    name: "Unterstützung von Terrorismus",
    subcategories: [], // No subcategories for this category
  },
  {
    id: "spam_or_misleading_content",
    name: "Spam oder irreführende Inhalte",
    subcategories: [
      { id: "mass_advertising", name: "Massenwerbung" },
      { id: "sales_of_medicines", name: "Verkauf von Arzneimitteln" },
      { id: "misleading_texts", name: "Irreführende Texte" },
      { id: "misleading_thumbnail", name: "Irreführende Thumbnail" },
      { id: "scam", name: "Betrug" },
    ],
  },
  {
    id: "violations_my_rights",
    name: "Verletzt meine Rechte",
    subcategories: [
      { id: "violation_of_my_copyrights", name: "Verletzt meine Urheberrechte" },
      { id: "violation_of_my_privacy", name: "Verletzung meiner Privatsphäre" },
      { id: "other_legal_claim", name: "Anderer Rechtsanspruch" },
    ],
  },
];
